import { render, staticRenderFns } from "./ChartC3JsStackedBar.vue?vue&type=template&id=74717710&"
import script from "./ChartC3JsStackedBar.vue?vue&type=script&lang=js&"
export * from "./ChartC3JsStackedBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports